import { Link } from "react-router-dom";
import { COMPANY, PRODUCTS } from "@/data/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1C2C22] text-[#F4F1EB] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <p className="overline text-[#8A9A86]">Let's collaborate</p>
            <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight mt-4">
              Let's build the future,<br />
              <span className="italic text-[#C27A62]">one paper roll</span> at a time.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="inline-flex items-center gap-3 mt-10 border-b border-[#F4F1EB]/50 pb-2 text-sm uppercase tracking-[0.25em] hover:text-[#C27A62] hover:border-[#C27A62] transition-colors"
            >
              Request a Quote →
            </Link>
          </div>
          <div className="md:col-span-5 grid grid-cols-2 gap-6 md:pt-14">
            <div>
              <p className="overline text-[#8A9A86]">Reach us</p>
              <div className="mt-4 space-y-3 text-sm font-body">
                {COMPANY.contacts.map((c) => (
                  <a
                    key={c.raw}
                    href={`tel:${c.raw}`}
                    data-testid={`footer-phone-${c.name.toLowerCase()}`}
                    className="block hover:text-[#C27A62]"
                  >
                    {c.name}<br />
                    <span className="text-[#8A9A86]">{c.phone}</span>
                  </a>
                ))}
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="block hover:text-[#C27A62] pt-2 text-[#8A9A86]"
                >
                  {COMPANY.email}
                </a>
              </div>
            </div>
            <div>
              <p className="overline text-[#8A9A86]">Products</p>
              <ul className="mt-4 space-y-3 text-sm">
                {PRODUCTS.map((p) => (
                  <li key={p.slug}>
                    <Link
                      to="/products"
                      data-testid={`footer-product-${p.slug}`}
                      className="hover:text-[#C27A62]"
                    >
                      {p.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-6 border-t border-[#F4F1EB]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#8A9A86]">
          <span>© {new Date().getFullYear()} {COMPANY.name}</span>
          <span>Made with paper · Not with plastic</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
